export const INTEREST_DELETE_WARNING =
    "Deleting it will also remove related objects. If this interest's view was used in a report definition, it will be removed from it.";
